import React, { Component } from "react";
import {
  Alert,
  Form,
  FormGroup,
  Col,
  Button,
  Row,
  CustomInput,
  Input,
  Label,
  Popover,
  PopoverHeader,
  PopoverBody,
  Badge,
} from "reactstrap";
import { canChangeToolPrivacy } from "../../../../utils/privacySettings";
import Tooltip from "../../../../components/UI/TooltipIcon/TooptipIcon";
import "../AddTool.css";
import Select from "react-select";
import * as url from "../../../../utils/url";
import {
  groupRoles,
  profilePicValidityCheck,
} from "../../../../utils/constants";

import axios from "../../../../axios";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import InviteAttendee from "../../../../components/InviteUser/InviteAttendee";
import "bootstrap/dist/css/bootstrap.min.css";

export default class PrivacySettings extends Component {
  constructor(props) {
    super(props);
    const decidePrivacy = () => {
      if (props.toolDetails.privacy != "") {
        if (
          props.toolDetails.privacy != "ENTERPRISE" &&
          props.toolDetails.invitedUsers &&
          props.toolDetails.invitedUsers.length
        ) {
          return "PRIVATE";
        } else {
          return props.toolDetails.privacy;
        }
      } else {
        return "PRIVATE";
      }
    };
    this.state = {
      // privacy: (this.props.toolDetails.privacy!=='') ? this.props.toolDetails.privacy:'PRIVATE',
      privacy: decidePrivacy(),
      permission:
        this.props.toolDetails.permission !== ""
          ? this.props.toolDetails.permission
          : "VIEW",
      // selectUsers:''
      isPrivacySettingsChanged: false,
      isSharedWithOrg: false,
      error: false,
      errorMessage: "",
      privacyPopoverOpen: false,
      inviteUserPopoverOpen:false,
      cohostPopover: false,
      invitees: [],
      hosts: [],
      permissionPopoverOpen: false,
      displayUsers: [],
      // isUserList: (this.props.toolDetails.invitedUsers && this.props.toolDetails.invitedUsers.length>0 )||
      // (this.props.toolDetails.privacy!=='' && this.props.toolDetails.privacy=='CUSTOM')  ? true: false,
      isUserList: true,
      invitedUsers:
        this.props.toolDetails.invitedUsers &&
        this.props.toolDetails.invitedUsers.length > 0
          ? this.props.toolDetails.invitedUsers
          : [],
      isToolAuthor:
        this.props.toolDetails.createdBy && this.props.toolDetails.createdBy._id
          ? true
          : false,
      currentTool: this.props.toolDetails,
      isToolCreate:
        this.props.toolDetails.createdBy == null ||
        this.props.toolDetails.createdBy._id == null ||
        this.props.toolDetails.createdBy == undefined ||
        this.props.toolDetails.createdBy._id == undefined
          ? true
          : false,
      invitedAllUsers: this.props.toolDetails.invitedAllUsers
        ? this.props.toolDetails.invitedAllUsers
        : null,
    };
  }

  componentWillUnmount() {
    this.state = {};
  }

  checkUpdateField = (val) => {
    console.log("val---", val);
    if (this.props.tool_status == "Edit") {
      this.props.updateToolFields(val);
    }
  };

  componentDidMount() {
    let { isUserList, isToolAuthor } = this.state;
    window.scrollTo(0, 0);
    this.getUserList();
    // if( isToolAuthor &&  this.props.toolDetails.createdBy._id===  this.props.user._id ){
    //   if(isUserList || this.state.privacy=='CUSTOM') {
    //     this.getUserList()
    //   }
    // }
  }

  getUserList = () => {
    let { displayUsers } = this.state;
    let { groupEvent } = this.props.user;

    if (displayUsers.length === 0) {
      axios
        .get(url.userListArray)
        .then((response) => {
          console.log("displayUsers------", response.data.data);
          let users = response.data.data.map((e) => {
            let name,
              firstName,
              lastName = "";

            if (e.firstName && e.lastName) {
              lastName = e.lastName;
              firstName = e.firstName;
              name = `${e.firstName}, ${e.lastName}`;
            } else if (e.firstName && !e.lastName) {
              name = `${e.firstName}`;
              firstName = e.firstName;
              lastName = "";
            }

            let u_item = {
              label: name,
              value: e._id,
              permissions: 0,
              profilePic:
                e.profilePic && profilePicValidityCheck(e.profilePic)
                  ? e.profilePic
                  : false,
              firstName,
              lastName,
              email: e.email,
            };

            if (groupEvent && groupEvent.groupId) {
              u_item = { ...u_item, groupId: groupEvent.groupId };
            }

            return u_item;
          });
          this.setState({ displayUsers: users });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  previewTool = () => {
    if (this.state.privacy === "") {
      this.setState({
        error: true,
        errorMessage: "Please choose privacy settings.",
      });
    } else {
      let localState = { ...this.state };
      const totalUsersInvited = this.state.invitedAllUsers ? this.state.displayUsers.length : this.state.invitees.length
      localState.isPrivacySettingsChanged = true;
      localState = this.deleteTempStateValues(localState);
      console.log("privacy/preview----", this.props, "------", this.state);

      this.props.showPreviewTool({ ...localState,totalUsersInvited:totalUsersInvited });
    }
  };

  deleteTempStateValues = (localState) => {
    // delete localState.error;
    // delete localState.errorMessage;
    // delete localState.selectedPrivacy;
    // delete localState.selectedPermission;
    // delete localState.privacyPopoverOpen;
    // delete localState.permissionPopoverOpen;
    return localState;
  };

  handleOptionChange = (changeEvent) => {
    console.log(changeEvent.target);
    let privacy = changeEvent.target.value;
    let permission = "";
    if (changeEvent.target.value === "ENTERPRISE") {
      permission = "VIEW";
      this.setState({
        privacy,
        permission,
        // invitedUsers: [],
        // isUserList:false
      });
    } else if (privacy === "PRIVATE") {
      this.setState({
        // isUserList: true,
        invitedAllUsers:null,
        privacy,
      });
      this.getUserList();
    } else {
      this.setState({
        privacy,
        permission: "VIEW",
        // invitedUsers:[],
        // isUserList:false
      });
    }
    this.checkUpdateField("privacy");
    this.checkUpdateField("permission");
    // this.checkUpdateField([{'privacy': privacy},{'permission':'View' }])
  };

  handlePermissionChange = () => {
    let permission = this.state.permission === "EDIT" ? "VIEW" : "EDIT";
    this.setState({ permission: permission });
    this.checkUpdateField("permission");
  };

  validateToolInfo = () => {
    let { toolDetails, user } = this.props;
    if (this.state.privacy === "") {
      this.setState({
        error: true,
        errorMessage: "Please choose privacy settings.",
      });
    } else if (
      this.state.privacy === "CUSTOM" &&
      this.state.invitedUsers.length == 0
    ) {
      this.setState({
        error: true,
        errorMessage:
          "Please select users you want to share this resource with.",
      });
      return;
    } else {
      const totalUsersInvited = this.state.invitedAllUsers ? this.state.displayUsers.length : this.state.invitees.length
      let localState = { ...this.state },
        event_owner;
      localState.isPrivacySettingsChanged = true;
      // localState.isSharedWithOrg = this.state.privacy === 'ALL';
      localState.isSharedWithOrg =
        this.state.privacy === "ENTERPRISE" ? true : false;
      localState = this.deleteTempStateValues(localState);

      this.props.onCompleted({ ...localState,totalUsersInvited:totalUsersInvited });
    }
  };

  goToPreviousStep = () => {
    this.props.goBackToPreviousStep();
  };

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
    });
    this.closePopOver("privacyPopoverOpen");
  };

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
    });
    this.closePopOver("permissionPopoverOpen");
  };

  cohostPopover = () => {
    this.setState({
      cohostPopover: !this.state.cohostPopover,
    });
    this.closePopOver("cohostPopover");
  };

  toggleInvitePop = () => {
    this.setState({
      invitePopoverOpen: !this.state.invitePopoverOpen,
    });
    this.closePopOver("invitePopoverOpen");
  };
  toggleInviteUserPop = () => {
    this.setState({
      inviteUserPopoverOpen: !this.state.inviteUserPopoverOpen,
    });
    this.closePopOver("inviteUserPopoverOpen");
  };

  closePopOver = (not_toggle) => {
    let obj = {
      permissionPopoverOpen: false,
      invitePopoverOpen: false,
      privacyPopoverOpen: false,
      cohostPopover: false,
    };
    delete obj[not_toggle];
    this.setState(obj);
  };

  onUserSelect = (u) => {
    console.log("u---", u);
    if (u && u.length != 0) {
      u.date = Date.now();
      u.isoDate = new Date().toISOString();
      u[u.length - 1].permissions = 0;
      this.setState({ invitedUsers: u, error: false });
    } else {
      this.setState({ invitedUsers: [] });
    }
    this.checkUpdateField("invitedUsers");
  };

  onUserSetPermissions = (p, u) => {
    console.log(p);
    let { invitedUsers } = this.state;
    if (p && p != null && p != undefined) {
      invitedUsers.forEach((item, index) => {
        if (item.value == u.value) invitedUsers[index].permissions = p.value;
      });
      this.setState({ invitedUsers });
    } else {
      invitedUsers.forEach((item, index) => {
        if (item.value == u.value)
          invitedUsers[index].permissions = { label: "View", value: 0 };
      });
      this.setState({ invitedUsers });
    }
  };

  setInvitees = (invitees) => {
    this.setState({ invitees });
  };

  displayPrivacySettings = () => {
    let {
      privacyPopoverOpen,
      isUserList,
      invitePopoverOpen,
      event_users,
      invitedUsers,
      permissionPopoverOpen,
      privacy,
      permission,
      displayUsers,
      error,
      isToolCreate,
      isToolAuthor,
      errorMessage,
      invitedAllUsers,
      inviteUserPopoverOpen,
      invitees
    } = this.state;

    let { toolDetails, user } = this.props,
      isEvents = toolDetails.category == "Conferences & Events",
      canChangePrivacy = canChangeToolPrivacy(toolDetails, user),
      isGroupEvent = false;

      let invitesEmailAlert = null

      let privacyAlert = null

      if(invitedAllUsers!=null && displayUsers && displayUsers.length){
        invitesEmailAlert = <Alert className="mx-5 text-center fonnt-weight-bold" color="warning"> {displayUsers.length} users will receive emails. </Alert>
      }else{
        if(invitees && invitees.length){
          invitesEmailAlert = <Alert className="mx-5 text-center fonnt-weight-bold" color="warning"> {invitees.length} users will receive emails. </Alert>
        }
      }

      if(invitedAllUsers != null){
          privacyAlert = <Alert className={"mx-5 mt-3 text-center fonnt-weight-bold"} color={"info"} > If invite all users option is selected then Privacy setting can only be Enterprise </Alert>
      }


    

    let { groupEvent } = this.props.user;

    if (groupEvent && groupEvent.groupId) {
      isGroupEvent = true;
    }

    if (isEvents && this.props.tool_status != "Edit") {
      return (
        <span>
           {
            invitesEmailAlert
          }

         
          <FormGroup className={`event_create_invite_users_container`} row>
            <Col sm={3} lg={3}>
            <div className="row float-right">
                <span className="privacy-settings-label float-right">
                  <span
                    id="invite-settings-popover2"
                    style={{ marginRight: "10px" }}
                    onClick={this.toggleInviteUserPop}
                  >
                    <Tooltip />
                  </span>
                  Select whom to invite
                </span>
                <Popover
                  placement="left"
                  isOpen={inviteUserPopoverOpen}
                  target="invite-settings-popover2"
                  toggle={this.toggleInviteUserPop}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Invite people to atted your event
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    {" "}
                    Invite users on platform to this event and they will see it
                    in their profile and list of events.
                  </PopoverBody>
                </Popover>
              </div>
            </Col>
            <Col sm={9} lg={9} className="">
              <div className="d-flex align-items-center">
                <span className="mr-2">Invite Selected Users</span>{" "}
                <Toggle
                  checked={invitedAllUsers != null}
                  onChange={(e) => {
                    if (e.target.checked) {
                      this.setState({
                        invitedAllUsers: new Date(),
                        privacy:"ENTERPRISE"
                      });
                    } else {
                      this.setState({
                        invitedAllUsers: null,
                      });
                    }
                  }}
                />{" "}
                <span className="ml-2">Invite All Users</span>
                {invitedAllUsers != null && (
                  <Badge color="success" className="ml-3">
                    {" "}
                    {displayUsers && displayUsers.length}{" "}
                  </Badge>
                )}
              </div>
            </Col>
          </FormGroup>
          {
            invitedAllUsers == null &&  <FormGroup className={`event_create_invite_users_container`} row>
            <Col sm={3} lg={3}>
              <div className="row float-right">
                <span className="privacy-settings-label float-right">
                  <span
                    id="invite-settings-popover"
                    style={{ marginRight: "10px" }}
                    onClick={this.toggleInvitePop}
                  >
                    <Tooltip />
                  </span>
                  Invite people to attend your event
                </span>
                <Popover
                  placement="left"
                  isOpen={invitePopoverOpen}
                  target="invite-settings-popover"
                  toggle={this.toggleInvitePop}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Invite people to atted your event
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    {" "}
                    Invite users on platform to this event and they will see it
                    in their profile and list of events.
                  </PopoverBody>
                </Popover>
              </div>
            </Col>
            <Col sm={7} lg={7} className="">
              <InviteAttendee
                mem_label={"Invitee(s)"}
                {...this.state}
                invitedUsers={this.state.invitedUsers}
                groupId={isGroupEvent ? groupEvent.groupId : false}
                setInvitees={this.setInvitees}
                item={toolDetails}
              />
            </Col>
          </FormGroup>
          }  

{
            privacyAlert
          }
        </span>
      );
    }
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  render() {
    let {
      privacyPopoverOpen,
      isUserList,
      event_users,
      invitedUsers,
      permissionPopoverOpen,
      privacy,
      permission,
      displayUsers,
      error,
      isToolCreate,
      isToolAuthor,
      errorMessage,
      invitedAllUsers,

    } = this.state;
    let alert = null;
    let { toolDetails, user } = this.props;

    if (error) {
      alert = <Alert color="danger">{errorMessage}</Alert>;
    }

    

    let isEvents = toolDetails.category == "Conferences & Events",
      canChangePrivacy = canChangeToolPrivacy(toolDetails, user),
      isGroupEvent = false,
      placeholder = "",
      collaborator_txt = "",
      popover_txt = "";

    let { groupEvent } = this.props.user;

    if (groupEvent && groupEvent.groupId) {
      isGroupEvent = true;
    }

    if (isEvents) {
      placeholder = "Select co-hosts for this event";
      collaborator_txt = "Add co-hosts";
      popover_txt = "Select co-hosts for this event";
    } else {
      placeholder = "Select collaborators";
      collaborator_txt = "Add collaborators";
      popover_txt = "Select collaborators for this event";
    }

    if (toolDetails && toolDetails.name) {
      return (
        <Form>
          {alert}

          {this.displayPrivacySettings()}

          <FormGroup className={`event_create_invite_users_container`} row>
            <Col sm={3} lg={3}>
              <div className="row float-right">
                <span
                  id="privacy-settings-popover"
                  style={{ marginRight: "10px" }}
                  onClick={this.togglePrivacySettings}
                >
                  <Tooltip />
                </span>
                <span className="privacy-settings-label float-right">
                  Privacy setting
                </span>
                <Popover
                  placement="left"
                  isOpen={privacyPopoverOpen}
                  target="privacy-settings-popover"
                  toggle={this.togglePrivacySettings}
                >
                  <PopoverHeader className="popover-header-tooltip">
                    Privacy Settings
                  </PopoverHeader>
                  <PopoverBody className="popover-body-tooltip">
                    Select "Private" to make this resource completely private;
                    so only those you invite or select will have access to this
                    resource. If you would like to share it with others in your
                    organization, select All Enterprise and then choose the kind
                    of permissions users in your enterprise can have.
                  </PopoverBody>
                </Popover>
              </div>
            </Col>
            <Col sm={8} lg={8} className="">
              <Row>
                <div className="radio ml0 mt0 p0">
                  <FormGroup check>
                    <Input
                      name="meRadio"
                      type="radio"
                      checked={privacy == "PRIVATE"}
                      value={"PRIVATE"}
                      onChange={this.handleOptionChange}
                    />{" "}
                    <Label check>
                      Private {isGroupEvent ? "for this group" : null}
                    </Label>
                  </FormGroup>
                  {/* <input id="meRadio" name="meRadio"
                        type="radio" value='PRIVATE' defaultChecked={privacy == "PRIVATE"} />
                      <label htmlFor="meRadio" className="radio-label privacy-radio-label privacy-radio-value">
                        &nbsp; Private {isGroupEvent?"for this group":null}
                      </label> */}
                </div>
              </Row>

              <Row>
                <div className="radio ml0 mt5 all_enterprise_privacy_opt">
                  <FormGroup check>
                    <Input
                      name="officeforAll"
                      type="radio"
                      checked={privacy == "ENTERPRISE"}
                      value={"ENTERPRISE"}
                      onChange={this.handleOptionChange}
                    />{" "}
                    <Label check>All Enterprise</Label>
                  </FormGroup>
                </div>

                {privacy == "ENTERPRISE" ? (
                  <span className="all_enterprise_privacy_permissions_container">
                    <div className="row all_enterprise_privacy_permissions">
                      <span className="permission-label">Permissions</span>
                      <span
                        id="permission-popover"
                        onClick={this.togglePersmission}
                      >
                        <Tooltip />
                      </span>

                      <Popover
                        placement="left"
                        isOpen={permissionPopoverOpen}
                        target="permission-popover"
                        toggle={this.togglePersmission}
                      >
                        <PopoverHeader className="popover-header-tooltip">
                          {" "}
                          Permissions
                        </PopoverHeader>
                        <PopoverBody className="popover-body-tooltip">
                          Toggle from “View Only” to “View and Edit” to allow
                          others you have shared this resource with, to make
                          modifications to it. Note, you can always change the
                          privacy settings and permissions again and/or at a
                          later time
                        </PopoverBody>
                      </Popover>
                    </div>
                    <div className="align-items-center all_enterprise_privacy_opt_view_edit">
                      <span className="permission-value">View Only</span>
                      <span className="ml10">
                        <Toggle
                          defaultChecked={permission == "EDIT"}
                          icons={false}
                          onChange={this.handlePermissionChange}
                        />
                      </span>
                      <span className="permission-value ml10">
                        View And Edit
                      </span>
                    </div>
                  </span>
                ) : null}
              </Row>
            </Col>
          </FormGroup>

          {toolDetails ? (
            <FormGroup className={`event_create_invite_users_container`} row>
              <Col sm={3} lg={3}>
                <div className="row float-right">
                  <span
                    id="cohost-popover"
                    style={{ marginRight: "10px" }}
                    onClick={this.cohostPopover}
                  >
                    <Tooltip />
                  </span>
                  <span className="privacy-settings-label float-right">
                    {collaborator_txt}
                  </span>
                  {/* chart-permission-label */}
                  <Popover
                    placement="top"
                    isOpen={this.state.cohostPopover}
                    target="cohost-popover"
                    toggle={this.cohostPopover}
                  >
                    <PopoverHeader className="popover-header-tooltip">
                      {collaborator_txt}
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                      {popover_txt}
                    </PopoverBody>
                  </Popover>
                </div>
              </Col>

              {isUserList === true ? (
                <div className="col-sm-8 col-md-8 col-lg-8">
                  <FormGroup
                    className={
                      this.props.isOwner ? "disabled-change-permission" : ""
                    }
                  >
                    <div className="vAlignTop">
                      {(isToolAuthor &&
                        toolDetails.createdBy._id === user._id) ||
                      isToolCreate ? (
                        <div>
                          <Select
                            isMulti={true}
                            multi={true}
                            isClearable={false}
                            clearable={false}
                            name="user-select"
                            placeholder={placeholder}
                            value={invitedUsers.length > 0 ? invitedUsers : ""}
                            isOpen={true}
                            options={displayUsers}
                            onChange={(itm) => this.onUserSelect(itm)}
                            className="basic-multi-select mb20"
                            classNamePrefix="select"
                          />
                          {invitedUsers.length > 0
                            ? invitedUsers.map((e) => {
                                return (
                                  <div key={e.value}>
                                    <div className="mb10">
                                      <Col
                                        sm={8}
                                        md={8}
                                        className="align-self-center inlineBlock vAlignTop"
                                      >
                                        {profilePicValidityCheck(
                                          e.profilePic
                                        ) ? (
                                          <img
                                            src={e.profilePic}
                                            className="toolkit_details_invited_u_pic"
                                          />
                                        ) : (
                                          <span
                                            className="toolkit_details_invited_users_u_initials"
                                            data-letters={this.getInitials(e)}
                                          />
                                        )}

                                        <span className="toolkit_details_invited_users_names">
                                          {e.label}
                                        </span>
                                      </Col>
                                      <Col
                                        sm={4}
                                        md={4}
                                        className="align-self-center inlineBlock vAlignTop"
                                      >
                                        <Select
                                          isClearable={false}
                                          name="permission-select"
                                          placeholder={
                                            "Select a permission/privacy"
                                          }
                                          value={e.permissions}
                                          isOpen={true}
                                          options={[
                                            { label: "View", value: 0 },
                                            { label: "Edit", value: 1 },
                                          ]}
                                          onChange={(itm) =>
                                            this.onUserSetPermissions(itm, e)
                                          }
                                          className="basic-multi-select"
                                          classNamePrefix="select"
                                        />
                                      </Col>
                                    </div>
                                  </div>
                                );
                              })
                            : null}
                        </div>
                      ) : (
                        <div>
                          {invitedUsers.length > 0
                            ? invitedUsers.map((e) => {
                                return (
                                  <div key={e.value}>
                                    <Row className="mb10">
                                      <Col
                                        sm={3}
                                        md={3}
                                        className="align-self-center"
                                      >
                                        <span>{e.label}</span>
                                      </Col>
                                    </Row>
                                  </div>
                                );
                              })
                            : null}
                        </div>
                      )}
                    </div>
                  </FormGroup>
                </div>
              ) : null}
            </FormGroup>
          ) : null}

          <FormGroup className="mt40">
            <Row>
              <Col sm={3}>
                <Button
                  className="float-left goBackBtn w100"
                  onClick={this.goToPreviousStep}
                >
                  <span className="goBackBtnTxt">
                    <span className="mr10 flaticon-back"></span> Go Back
                  </span>
                </Button>
              </Col>
              <Col sm={{ size: 3, offset: 3 }}>
                <Button
                  className="float-right goBackBtn w100"
                  onClick={this.previewTool}
                >
                  <span className="goBackBtnTxt">
                    <span className="ml10 flaticon-vision"></span> Preview{" "}
                    <span />
                  </span>
                </Button>
              </Col>
              <Col sm={3}>
                <Button
                  className="float-right continueBtn ml10 w100"
                  onClick={this.validateToolInfo}
                  disabled={
                    invitedAllUsers && privacy !=="ENTERPRISE"
                  }
                >
                  <span className="continueBtnTxt">
                    Submit <span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>
              </Col>
            </Row>
          </FormGroup>
        </Form>
      );
    } else {
      return <span>Loading..</span>;
    }
  }
}
